import { UseQueryResult } from '@tanstack/react-query'
import { Card, CardBody } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Bilancia } from '../../types'

interface CardClienteBilanciaInterface {
  // TODO: probabilemnte cliente_pk e cliente_ragione_sociale non sono opzionali, da verificare in bilancia
  cliente_pk?: Bilancia['cliente_pk']
  cliente_ragione_sociale?: Bilancia['cliente_ragione_sociale']
  sede_data: {
    numero_rea: Bilancia['sede_data']['numero_rea']
    toponimo_data?: {
      nome: NonNullable<Bilancia['sede_data']['toponimo_data']>['nome']
    }
    via: Bilancia['sede_data']['via']
    civico: Bilancia['sede_data']['civico']
    comune_data?: {
      nome: NonNullable<Bilancia['sede_data']['comune_data']>['nome']
    }
    provincia_data?: {
      sigla: NonNullable<Bilancia['sede_data']['provincia_data']>['sigla']
    }
  }
  reparto: Bilancia['reparto']
  zona_utilizzo: Bilancia['zona_utilizzo']
}

type CardClienteProps = {
  bilancia: UseQueryResult<CardClienteBilanciaInterface, Error>
}

export default function CardCliente({ bilancia }: CardClienteProps) {
  return (
    <Card className="mt-3 mb-3">
      <CardBody>
        <div className="py-1 border-bottom">
          <div className="d-flex justify-content-between">
            <h4 className="heading-h4">Cliente</h4>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-8">
            <div className="label-m text-body-secondary">Nome cliente</div>
            <div className="p-md mt-2">
              <Link to={`/clienti/${bilancia.data?.cliente_pk}`} className="link-md text-body-secondary">
                {bilancia.data?.cliente_ragione_sociale}
              </Link>
            </div>
          </div>
          <div className="col-md-3">
            <div className="label-m text-body-secondary">Numero REA</div>
            <div className="p-md mt-2">{bilancia.data?.sede_data?.numero_rea}</div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-8">
            <div className="label-m text-body-secondary">Indirizzo</div>
            <div className="p-md mt-2">
              {bilancia.data?.sede_data?.toponimo_data?.nome} {bilancia.data?.sede_data?.via}
              {bilancia.data?.sede_data?.civico && `, ${bilancia.data?.sede_data?.civico}`}-{' '}
              {bilancia.data?.sede_data?.comune_data?.nome} ({bilancia.data?.sede_data?.provincia_data?.sigla})
            </div>
          </div>
          <div className="col-md-4">
            <div className="label-m text-body-secondary">Reparto</div>
            <div className="p-md mt-2">{bilancia.data?.reparto}</div>
          </div>
          <div className="col-md-4 mt-3">
            <div className="label-m text-body-secondary">Zona utilizzo</div>
            <div className="p-md mt-2">{bilancia.data?.zona_utilizzo}</div>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}
